import { render, staticRenderFns } from "./TableFooterPagination.vue?vue&type=template&id=6a3e76aa&"
import script from "./TableFooterPagination.vue?vue&type=script&setup=true&lang=js&"
export * from "./TableFooterPagination.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports